module.exports = __webpack_public_path__ + "static/media/icon-stands.e8807d9f.svg";